export default {
  // START:: GET APP THEME
  getAppTheme(state) {
    return state.Dos_admin_dashboard_theme;
  },
  // END:: GET APP THEME GETTER
};
